module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTDXX7jbW7zjX8DXX7jbX7jnd9zbY7zrc8jXX7zXX7jXX7TXX7jXX7jjX7zbX7zXW7p6soT4AAAAQdFJOUwDkcDCy8BNBH3+g17/QUm2P+EQfAAAAQ0lEQVQI1zWLQQ7AIAzDUgaFjjHy/9euQJeDZUUycKbjDsNk/rXzDasUZ7ocmQY0luag7uOBcfcqNGGNhByRp9JX+gFYYwHLaxg0SgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/path-2.png
// module id = BbzK
// module chunks = 88